// Generated by CoffeeScript 1.12.7
(function() {
  var MapExtensions;

  module.exports = MapExtensions = (function() {
    function MapExtensions() {}

    MapExtensions.iteratorToArray = function(iterator) {
      var obj, out;
      out = [];
      while (!(obj = iterator.next()).done) {
        out.push(obj.value);
      }
      return out;
    };

    MapExtensions.mapToKeysArray = function(map) {
      return MapExtensions.iteratorToArray(map.keys());
    };

    MapExtensions.mapToValuesArray = function(map) {
      return MapExtensions.iteratorToArray(map.values());
    };

    return MapExtensions;

  })();

}).call(this);

//# sourceMappingURL=MapExtensions.js.map
